import Checkbox from "../../../Common/Components/Checkbox";
import Speed from "../../../../assets/img/icons/Speed.svg";
import Elipsis from "../../../../assets/img/icons/Elipsis.svg";
import List from "../../../../assets/img/icons/ArticlePopover/lowerList/list.svg";
import Profile from "../../../../assets/img/icons/ArticlePopover/lowerList/profile.svg";
import Frame from "../../../../assets/img/icons/ArticlePopover/lowerList/frame.svg";
import Delete from "../../../../assets/img/icons/ArticlePopover/lowerList/Delete.svg";
import Search from "../../../../assets/img/icons/ArticlePopover/lowerList/search.svg";

import { Popover } from "antd";

const UserPopoverTitle = (
  <div className="padding-top-sm padding-bottom-sm padding-right-md">
    <h4 className="mb-0">Edit Contact</h4>
  </div>
);
const UserPopoverContent = (
  <div className="BlogItemDropdown">
    <ul className="me-4">
      <li className="d-flex mb-1">
        <img src={Search} alt="" /> &nbsp;Find Articles of interest
      </li>
      <li className="d-flex mb-1">
        <img src={Profile} alt="" /> &nbsp;Find similar Contacts
      </li>
      <li className="d-flex mb-1">
        <img src={Frame} alt="" /> &nbsp;Add to an existing asset…
      </li>
      <li className="d-flex mb-1">
        <img src={Profile} alt="" /> &nbsp;Analyze this Contact
      </li>
      <li className="d-flex mb-1">
        <img src={List} alt="" /> &nbsp;Add to a List…
      </li>
      <li className="d-flex mb-1">
        <img src={Delete} alt="" /> &nbsp;Delete Contact
      </li>
    </ul>
  </div>
);

interface IUserListItemProps {
  imgUrl?: string;
  imgUrlTwo?: string;
  imgUrlThree?: string;
  name?: string;
  contacts?: string;
  engagement?: number;
}

const UserListItem: React.FC<IUserListItemProps> = (props) => {
  return (
    <tr>
      <td className="checkbox">
        <Checkbox />
      </td>
      <td>
        <div className="profile-thumb">
          <img src={props.imgUrl} className="profile-img-v1" />
          <img src={props.imgUrlTwo} className="profile-img-v2" />
          <img src={props.imgUrlThree} className="profile-img-v3" />
        </div>
        <div className="profile">
          <strong className="name">{props.name}</strong>
        </div>
      </td>
      <td>
        <span className="industrie"> {props.contacts}</span>
      </td>
      <td>
        <Popover
          title={UserPopoverTitle}
          content={UserPopoverContent}
          overlayClassName="BlogPopover"
          placement="leftTop"
          trigger="click"
        >
          <a className="px-2 float-right">
            <img src={Elipsis} />
          </a>
        </Popover>
        <div className="engagement">
          <img src={Speed} />
          &nbsp;
          {props.engagement}
        </div>
      </td>
    </tr>
  );
};

export default UserListItem;

UserListItem.defaultProps = {
  imgUrl:
    "https://www.fudzilla.com/media/k2/items/cache/129285d38a9f0d67e7a81e2f4e0004ca_L.jpg",
  imgUrlTwo:
    "https://www.fudzilla.com/media/k2/items/cache/129285d38a9f0d67e7a81e2f4e0004ca_L.jpg",
  imgUrlThree:
    "https://www.fudzilla.com/media/k2/items/cache/129285d38a9f0d67e7a81e2f4e0004ca_L.jpg",
  name: "Smart or Regular List Name Here",
  contacts: "25 contacts",
  engagement: 1302,
};
